define('shared/initializer/form/adapters/NativeForm',[
    'shared/lib/ctor',
    './Form',
    './mixins/PlaceholderEnableable',
    './mixins/SubmitButtonEnableable'
],
function (
    ctor,
    Base,
    PlaceholderEnableable,
    SubmitButtonEnableable
    
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;

        me.base.apply( null, arguments );

        me.mixin(
            SubmitButtonEnableable, 
            PlaceholderEnableable
        );

    }).inherit(Base);

    return Ctor;
});

